import { Navigate } from 'react-router-dom';

/** Redirection legacy → hub Packs & Services */
const CommercialPackagesManagement = () => (
  <Navigate to="/admin/packs-services?tab=packages" replace />
);

export { CommercialPackagesContent } from './CommercialPackagesContent';
export default CommercialPackagesManagement;
